import service, { get, post, Delete } from '@/utils/https';

export const fetchFreelancers = (params) => {
  return get('/api/app/v1/freelancers', params);
};

export const inviteFreelancer = (data) => {
  return post('/api/app/v1/freelancers/invite', data);
};

export const submitFreelancerOnboarding = (data) => {
  return service.post('/api/app/v1/freelancers/onboarding', data, { hideMessageModal: true })
}

export const getFreelancerOnboardingStatus = () => {
  return service.get('/api/app/v1/freelancers/onboarding-status');
};

export const getFreelancersDetail = (user_id) => {
  return service.get(`/api/app/v1/freelancers/${user_id}`);
};

export const freelancerProfileEdit = (data) => {
  return service.put('/api/app/v1/freelancers/profile/edit', data, { hideMessageModal: true });
};

export const getFreelancerTeams = () => {
  return service.get('/api/app/v1/freelancers/teams');
};

export const saveFreelancerDocument = (data) => {
  return service.post('/api/app/v1/freelancers/documents', data, { hideMessageModal: true });
};

/** @param {File | null | undefined} frontFile */
/** @param {File | null | undefined} backFile */
export const saveDriverLicensePair = (frontFile, backFile) => {
  const formData = new FormData();
  if (frontFile) formData.append('front', frontFile);
  if (backFile) formData.append('back', backFile);
  return service.post('/api/app/v1/freelancers/documents/driver-license-pair', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteFreelancerDocument = (documentId) => {
  return service.delete(`/api/app/v1/freelancers/documents/${documentId}`);
};

export const verifyFreelancerDocument = (documentId, { sirenOverride } = {}) => {
  const payload = { document_id: documentId };
  if (sirenOverride) payload.siren_override = sirenOverride;
  // OCR + validation can take several minutes on large PDFs (backend maxDuration 240s).
  return service.post('/api/app/v1/freelancers/documents/verify', payload, {
    timeout: 240 * 1000,
    hideMessageModal: true,
  });
};

export const initiateNonRemunerationSignature = (payload) => {
  return service.post(
    '/api/app/v1/freelancers/attestation-non-remuneration/initiate',
    payload
  );
};

export const markAttestationAwaitingWebhookValidation = (documentId) => {
  return service.post(
    '/api/app/v1/freelancers/attestation-non-remuneration/mark-awaiting-validation',
    { document_id: documentId }
  );
};

export const resumeAttestationSigning = (payload = {}) => {
  return service.post(
    '/api/app/v1/freelancers/attestation-non-remuneration/resume-signing',
    payload,
    { hideMessageModal: true }
  );
};

export const updateFreelancer = (id, data, config = {}) => {
  return service.patch(`/api/app/v1/freelancers/${id}`, data, config);
};

/** Personal favorite toggle (team-scoped, current user). */
export const setFreelancerFavorite = (id, isFavorite) => {
  return service.put(
    `/api/app/v1/freelancers/${id}/favorite`,
    { is_favorite: isFavorite },
    { hideMessageModal: true }
  );
};

export const getJobTitles = () => {
  return service.get('/api/app/v1/freelancers/job-titles');
};

export const deleteFreelancerInvitation = (invitationId) => {
  return Delete(`/api/app/v1/freelancers/invitations/${invitationId}`);
};

export const updateFreelancerInvitation = (invitationId, data) => {
  return service.patch(`/api/app/v1/freelancers/invitations/${invitationId}`, data);
};

export const importFreelancersCsv = (data) => {
  return post('/api/app/v1/freelancers/import-csv', data);
};

export const fetchFreelancersExport = (params) => {
  return get('/api/app/v1/freelancers/export', params);
};

export default {
  fetchFreelancers,
  inviteFreelancer,
  getFreelancerOnboardingStatus,
  submitFreelancerOnboarding,
  getFreelancersDetail,
  getFreelancerTeams,
  saveFreelancerDocument,
  deleteFreelancerDocument,
  updateFreelancer,
  setFreelancerFavorite,
  getJobTitles,
  deleteFreelancerInvitation,
  updateFreelancerInvitation,
  importFreelancersCsv,
  fetchFreelancersExport,
  initiateNonRemunerationSignature,
  markAttestationAwaitingWebhookValidation,
  resumeAttestationSigning,
};
